module.exports = __webpack_public_path__ + "static/media/matilde-cap-sri-lanka-hello.09bf2e6d.png";